var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/css-loader/index.js??ref--8-1!../../../../node_modules/postcss-loader/src/index.js??ref--8-2!../../../../node_modules/less-loader/dist/cjs.js??ref--8-3!./DescriptionSection.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};